import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Header from "./Header";
import Footer from "./Footer";
import { toast } from "react-toastify";
import { server } from "../server";

function Login() {
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const isValidMobile = /^\d{10}$/.test(mobile);

  const handleLogin = async () => {
    if (!isValidMobile) return;

    try {
      setLoading(true);

      const response = await fetch(`${server}/auth/Login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mobile: Number(mobile),
        }),
      });

      const result = await response.json();
      setLoading(false);

      if (response.ok) {
        navigate("/verify-otp", { state: { mobile } });
      } else {
        if (result?.error === "User not found") {
          toast.error("Not registered, Register Now");
        } else {
          toast.error("Login Failed");
        }
      }
    } catch (error) {
      setLoading(false);
      toast.error("Something Went Wrong");
    }
  };

  return (
    <>
      <Header />

      <section className="py-7 gradient-section-1">
        <div className="container d-flex justify-content-center align-items-center">
          <div className="col-lg-6 col-md-8 col-12">
            <div className="rounded-5 p-7 bg-white text-center shadow">
              <span className="text-uppercase fw-semibold ls-md text-dark">
                Login with OTP
              </span>

              <h2 className="fw-normal ls-sm lh-1 mt-1">
                Enter Registered Mobile No.
              </h2>

              <p className="lh-sm m-0 text-secondary">
                We’ll send you an OTP to verify your number
              </p>

              <div className="d-flex justify-content-center mt-4">
                <TextField
                  className="w-lg-75 w-100 ls-sm"
                  label="Mobile No."
                  variant="standard"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                  inputProps={{ maxLength: 10 }}
                />
              </div>

              <div className="d-flex justify-content-center mt-4">
                {loading ? (
                  <div
                    class="spinner-border text-red-primary"
                    role="status"
                  ></div>
                ) : (
                  <button
                    disabled={!isValidMobile || loading}
                    onClick={handleLogin}
                    className="btn bg-red-primary text-white fw-normal shadow fs-4 rounded-pill border-0 px-7"
                  >
                    Continue
                  </button>
                )}
              </div>

              <p className="mt-4 text-secondary fs-5 lh-sm">
                By continuing, you agree to our <br />
                <span className="text-primary">Terms of Service</span>
              </p>

              <p className="mt-3 text-secondary fs-5">
                Don’t have an account?{" "}
                <Link to="/" className="text-red-primary">
                  Register
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Login;
